<template>
    <div
        class="md notification"
        :class="status"
        @mouseenter="clearTimer"
        @mouseleave="addTimer"
    >
        <div class="toggle">
            <a @click.prevent="close"></a>
        </div>
        <div class="content">
            <span>{{content.html}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            return {
                timer: null,
                delay: 0
            }
        },
        computed: {
            status: function(){
                if( this.content.status ){
                    return 'is-'+ this.content.status;
                }else {
                    return 'is-success';
                }
            }
        },
        methods: {
            close: function(_key){
                this.clearTimer();
                this.$emit('sendEvent', 'clearNotification', this.sn);
            },
            clearTimer: function(){
                if( this.delay !== 0 ){
                    window.clearTimeout(this.timer);
                }
            },
            addTimer: function(){
                
                if( this.delay !== 0 ){

                    this.clearTimer();

                    this.timer = window.setTimeout(() => {
                        this.close()
                    }, this.delay);
                }
            }
        },
        created: function(){
            if( this.content.delay !== undefined && typeof this.content.delay === 'number' ){ //設定為 0 不會自動修除
                this.delay = this.content.delay;
            }else {
                this.delay = 4000;
            }

            this.addTimer();
        }
    }
</script>

<style scoped lang="scss">

    .md.notification {
        position: relative;
        padding: $interval-xl $interval-xxl;
        background-color: rgba-set($major-color, $opacity-h);
        backdrop-filter: saturate(120%) blur(4px);
        border-color: $black;
        border-radius: $border-radius;
        transform: $transition;

        @include media('pad') {
            padding: $interval-l $interval-xl;
        }

        @include media('phone') {
            padding: $interval-m $interval-l;
        }

        // &:hover {
        //     background-color: $bg;
        // }

        // @each $key, $map in $colors {
        //     $bg: map-get($map, 'background');
        //     $bd: map-get($map, 'border');
        //     $tx: map-get($map, 'text');

        //     &.is-#{$key} {
        //         background-color: $bg;
        //         background-color: rgba($bg, $opacity-vh);
        //         border-color: $bd;
        //         color: $tx;

        //         &:hover {
        //             background-color: $bg;
        //         }
        //     }
        // }

        + .md.notification {
            margin-top: $interval-s;
        }

        .toggle {
            // $size: 20px;
            display: none;

            // a {
            //     position: absolute;
            //     top: 0;
            //     right: 0;
            //     width: $size;
            //     height: $size;
            //     line-height: $size;
            //     text-align: center;
            //     cursor: pointer;

            //     &::after {
            //         @extend %font-pseudo;
            //         margin-right: 0;
            //         content: '\e5cd';
            //         font-size: 1.3em;
            //         line-height: 1;
            //     }
            // }
        }

        .content {
            color: $white;
            font-size: $font-size-xl;

            > span {
                vertical-align: middle;
            }

            &::before {
                @extend %font-pseudo;
                content: '\f052';
                margin-right: $interval-s;
                font-size: $font-size-xxxl;
                vertical-align: middle;
            }

            @include media('phone') {
                font-size: $font-size-l;
            }
        }
    }
</style>
